<ion-button *ngIf="hasItems" (click)="open($event)" fill="clear" size="full">
  <ion-icon slot="icon-only" size="large" name="attach"></ion-icon>
</ion-button>
